import styles from './SidebarPage.module.css'
import React, { useMemo, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Slider } from 'antd'
import { FormBuilderContext } from '../../../store/store.FormBuilder'

const SidebarPage = observer(() => {
  const storeFormBuilder = useContext(FormBuilderContext)
  return <div className={styles.sidebarPage}></div>
})

export default SidebarPage
